const Constants = Object.freeze({
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  FILE_TYPES: {
    graduationCertificate: "graduation_certificate",
    graduationCertificateApplication: "graduation_certificate_application",
    identityFront: "identity_front",
    identityBack: "identity_back",
    form086: "form_086",
    entCertificate: "ent_certificate",
    englishCertificate: "english_certificate",
    image3x4: "image_3x4",
    benefitConfirmationDocDorm: "benefit_confirmation_doc_dorm",
    vaccinationPassport: "vaccination_passport",
    documentConfirmingAvailabilityOfInternalGrant:
      "document_confirming_availability_of_internal_grant",
    documentConfirmingSocialStatus: "document_confirming_social_status",
    olympiadCertificate: "olympiad_certificate",
    pripisnoiBilet: "pripisnoi_bilet",
    grantCertificate: "grant_certififcate",
    paymentReceipt: "payment_peceipt",
    copyGraduationCertificate: "copy_graduation_certificate",
    achievementDocument: "achievement_doc",
  },
});

export default Constants;
